// Text message settings form handlers

const formWrapper = $("#form-wrapper");

function displayError(message: string): void {
    const msg = formWrapper.message(message, {
        append: false,
        classes: ['red-gradient'],
        animate: false,
    });
    msg.bind('endfade', function () {
    }).hide().slideDown('fast');
}

export function updateTime(): void {
    const vv = $('#selMode').val();
    if (vv === 'custom') {
        $('#divTimes').show();
    } else {
        $('#divTimes').hide();
    }
}

export function initForm(): void {
    // Read saved times from data attribute
    const timesData = $('#settings').data('times') as string[] || [];
    const ttt: string[] = typeof timesData === 'string'
        ? JSON.parse(timesData)
        : timesData;

    updateTime();

    for (let i = 0; i < ttt.length; i++) {
        const s = ttt[i];
        if (s != null && s.length > 1) {
            const mm = $("*[value='" + s + "']");
            if (mm.length > 0) (mm[0] as HTMLInputElement).checked = true;
        }
    }

    // Call template init
    ($ as any).template.init();

    // Color
    $('#anthracite-inputs').change(function () {
        $('#main')[(this as HTMLInputElement).checked ? 'addClass' : 'removeClass']('black-inputs');
    });

    // Switches mode
    $('#switch-mode').change(function () {
        $('#switch-wrapper')[(this as HTMLInputElement).checked ? 'addClass' : 'removeClass']('reversed-switches');
    });

    // Disabled switches
    $('#switch-enable').change(function () {
        ($('#disabled-switches').children() as any)[(this as HTMLInputElement).checked ? 'enableInput' : 'disableInput']();
    });

    // Tooltip menu
    ($('#select-tooltip') as any).menuTooltip($('#select-context').hide(), {
        classes: ['no-padding'],
    });

    // Date picker
    ($('.datepicker') as any).glDatePicker({ zIndex: 100 });

    // Form validation
    ($('form') as any).validationEngine();

    $('#settings').submit(function (event) {
        event.preventDefault();
        $.post('/accts?p=12',
            $('#settings').serialize(),
            function (data) {
                formWrapper.clearMessages();
                displayError(data);
            }
        );
    });
}
